import { useCopilotMeta } from '@customerio/hydra-copilot/react';
import { Badge, Tooltip } from '@customerio/pluma-components/react';

import { useCopilotSessionContext } from './session-provider';
import { isUnnamedSession } from '../utils/session-name';

const AGENT_BETA_TOOLTIP =
  'The Agent is in beta while we refine the experience. Your feedback helps us make it more useful for your team.';

/**
 * Purple Beta label with tooltip; renders nothing when the session is named.
 */
export function AgentBetaLabel() {
  const session = useCopilotSessionContext();
  const meta = useCopilotMeta(session);
  const isVisible = isUnnamedSession(meta.name);

  if (!isVisible) {
    return null;
  }
  return (
    <Tooltip content={AGENT_BETA_TOOLTIP} placement="top" isCustom={true}>
      {(context) => (
        <Badge color="violet" ref={context.reference.setReference} {...context.reference.getReferenceProps()}>
          Beta
        </Badge>
      )}
    </Tooltip>
  );
}
